import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'

const { unit, half } = measures

export const card = css`
  box-shadow: 0 ${half}px ${unit}px 0 ${colors.black20};
  transition: 300ms;

  text-align: center;

  width: ${25 * unit}px;

  :hover {
    box-shadow: 0 ${unit}px ${2 * unit}px 0 ${colors.black20};
  }
`

export const caption = css`
  padding: ${2 * unit}px;
`
